import { useEffect, useState } from 'react';

export default function useGeolocation() {
    const [position, setPosition] = useState({ lat: null, lon: null, accuracy: null });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!navigator.geolocation) {
            setError('Геолокация не поддерживается браузером');
            setLoading(false);

            return;
        }

        const watchId = navigator.geolocation.watchPosition(
            (pos) => {
                setPosition({
                    lat: pos.coords.latitude,
                    lon: pos.coords.longitude,
                    accuracy: pos.coords.accuracy
                });
                setLoading(false);
                setError(null);
            },
            (err) => {
                setError(`Ошибка геолокации: ${err.message}`);
                setLoading(false);
            }, { enableHighAccuracy: true, maximumAge: 5000, timeout: 10000 }
        );

        return () => navigator.geolocation.clearWatch(watchId);
    }, [])

    return { ...position, error, loading };
}
